import { useState, useEffect } from 'react';

const useWindowLocationHash = (itemsArray) => {
	const [windowLocationHash, setWindowLocationHash] = useState(null);

	useEffect(() => {
		if (itemsArray.length > 0 && window.location.hash) {
			const itemId = window.location.hash.slice(1);
			setWindowLocationHash(itemId);
		}
	}, [itemsArray]);

	return [windowLocationHash, setWindowLocationHash];
}

export default useWindowLocationHash;